import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_inventarSpells} from "../_signals/s_char";
import {ICharInventarSpell} from "../_interfaces/ICharInventarSpell";

export const InventarSpellsGet = (cid: string) => {
    fetch(apiAddress + "/char/inventarspells/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('BESpells get reponse', data);
                if (data.hasOwnProperty('result')) {
                    s_char_inventarSpells.value = (data.result as ICharInventarSpell[])
                }
            }
        )
        .catch((reason => {
            console.log('BEInventarSpells get catch', reason);
        }))
}

export const InventarSpellsCreate = (spell: ICharInventarSpell) => {
    fetch(apiAddress + "/char/inventarspells/", createOptions('CREATE', spell))
        .then((res) => res.json())
        .then((data) => {
                console.log('BEInventarSpells create reponse', data);
                if (data.hasOwnProperty('result')) {
                }
            }
        )
        .catch((reason => {
            console.log('BEInventarSpells create catch', reason);
        }))
}

export const InventarSpellsUpdate = (spell: ICharInventarSpell) => {
    fetch(apiAddress + "/char/inventarspells/", createOptions('UPDATE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BESpells update response', data))
        .catch((reason => {
            console.log('BEInventarSpells update catch', reason);
        }))
}

export const InventarSpellsDelete=(spell: ICharInventarSpell)=> {
    fetch(apiAddress + "/char/inventarspells/", createOptions('DELETE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BESpells delete response', data))
        .catch((reason => {
            console.log('BEInventarSpells delete catch', reason);
        }))
}